import { Injector } from '@angular/core';
import { UIRouter } from '@uirouter/core';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { CurrentPlanService } from 'src/app/components/plans/current-plan.service';
import { CompanyAssetsService } from 'src/app/shared/services/company-assets.service';

export interface E2eTestHooks {
  initPlanTrial(): void;
  setUserRoles(roles: string[]): void;
  setCompanyIndustry(companyIndustry: string): void;
  unlockFrontendFeatures(): void;
  setCompanyHasPresentations(hasPresentations: boolean): void;
  getSelectedCompanyId(): string | null;
  goToState(
    stateName: string,
    params?: Record<string, unknown>,
    options?: Record<string, unknown>,
  ): Promise<unknown>;
}

declare global {
  interface Window {
    __rvE2e__?: E2eTestHooks;
  }
}

export function installE2eTestHooks(injector: Injector): void {
  const currentPlanService = injector.get(CurrentPlanService);
  const userStateService = injector.get(UserStateService);
  const companyStateService = injector.get(CompanyStateService);
  const companyAssetsService = injector.get(CompanyAssetsService);
  const uiRouter = injector.get(UIRouter);

  window.__rvE2e__ = {
    initPlanTrial: () => currentPlanService.initPlanTrial(),
    setUserRoles: (roles: string[]) => {
      const profile = userStateService.getCopyOfProfile(true);

      userStateService.updateUserProfile({ ...profile, roles: [...roles] });
    },
    setCompanyIndustry: (companyIndustry: string) => {
      const company = companyStateService.getCopyOfSelectedCompany(true);

      companyStateService.updateCompanySettings({
        ...company,
        companyIndustry,
      });
    },
    unlockFrontendFeatures: () => {
      const company = companyStateService.getCopyOfSelectedCompany(true);

      companyStateService.updateCompanySettings({
        ...company,
        unlockAllFeatures: true,
      });
      currentPlanService.isUnlimitedPlan = () => false;
      Object.assign(currentPlanService.currentPlan, {
        isPurchasedByParent: false,
        playerProAvailableLicenseCount: 1,
        playerProTotalLicenseCount: 1,
      });
    },
    setCompanyHasPresentations: (hasPresentations: boolean) => {
      companyAssetsService.hasPresentations = () =>
        Promise.resolve(hasPresentations);
    },
    getSelectedCompanyId: () => companyStateService.getSelectedCompanyId(),
    goToState: (stateName, params = {}, options = {}) => {
      return uiRouter.stateService.go(stateName, params, options);
    },
  };
}
